import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import * as fromApp from '@store';
import { DocumentService } from '@core/api/document.service';

export interface DialogData {
  filename: string;
  description: string;
  docTypeId: number;
  comments: string;
  isAdmin: boolean;
}

@Component({
    selector: 'fc-dialog-upload-doc',
    templateUrl: './dialog-upload-doc.component.html',
    styleUrls: ['./dialog-upload-doc.component.scss'],
    standalone: false
})
export class DialogUploadDocComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  docUploadForm: UntypedFormGroup;
  docTypes = [];

  constructor(
    public dialogRef: MatDialogRef<DialogUploadDocComponent>,
    readonly formBuilder: UntypedFormBuilder,
    readonly store: Store<fromApp.AppState>,
    readonly documentService: DocumentService,
    readonly router: Router,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.docUploadForm = this.formBuilder.group({
      docType: [data.docTypeId, Validators.required],
      description: data.description,
      comments: data.comments,
    });
  }

  ngOnInit() {
    this.docTypes = this.documentService.docTypes
      .filter(d => this.data.isAdmin ? true : !d.isPrivate).map(t => ({ value: t.id, viewValue: t.name }))
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  saveDocument() {
    this.dialogRef.close({
      description: this.docUploadForm.controls.description.value,
      docTypeId: this.docUploadForm.controls.docType.value,
      comments: this.docUploadForm.controls.comments.value,
    });
  }
}
